import { flatten } from 'lodash';
import Partutil from './partutil.js';

function GameVariables(gamedata) {
  this.gamedata = gamedata;
}

GameVariables.prototype.getVariablesFor = function (transformsAndSource) {
  const globalVariables = this.getGlobalVariables();

  const origin = {
    source: transformsAndSource.source,
    from: transformsAndSource.from
  }
  const sceneVariables = transformsAndSource.from.variables.map(this.enrichVariables.bind(this, origin));

  const variables = globalVariables.concat(sceneVariables);
  return variables;
}

GameVariables.prototype.getVariablesForTransform = function (transformsAndSource, transform) {

  const variables = this.getVariablesFor(transformsAndSource);
  const origin = {
    source:'transform',
    from:transform
  }

  const transformVariables = (transform.variables||[]).map(this.enrichVariables.bind(this, origin));


  const partutil = new Partutil(transformsAndSource);
  const parents = partutil.getParentsForTransform(transform)||[];

  const ancestorVariables = flatten(parents.map( (parent) => {
    const origin = {
      source: 'ancestor',
      from: parent
    }
    return parent.variables.map(this.enrichVariables.bind(this, origin));
  }));

  return variables.concat(ancestorVariables).concat(transformVariables);
}

GameVariables.prototype.getGlobalVariables = function () {
  const origin = {
    source:'gamedata',
    from:'gamedata'
  }
  return this.gamedata.variables.map(this.enrichVariables.bind(this, origin));
}

GameVariables.prototype.enrichVariables = function (origin, variable) {
  return {origin,variable};
}

export default GameVariables;
